'use client';

import { Button } from '@/components/ui';
import { AnimatePresence, cn, motion } from '@/libs';
import { useModalStore } from '@/stores';

export const Modal = () => {
  const modal = useModalStore((state) => state.modals[0]);
  const closeModal = useModalStore((state) => state.closeModal);
  const preventingComponent = useModalStore((state) => state.preventingComponent);

  const handleOverlayClick = () => {
    if (modal && !modal.hardClose) closeModal(modal.id);
  };

  const handleCloseButton = () => {
    modal.onCloseOptional?.();
    handleOverlayClick();
  };

  const isVerifyModal = modal?.className?.includes('verify');

  return (
    <AnimatePresence mode="wait">
      {modal && (
        <motion.div
          key={modal.id}
          data-cy="modal"
          className={cn(
            'fixed inset-0 flex items-center justify-center',
            modal.priority && modal.priority > 0 ? 'z-[2100]' : 'z-[1000]',
          )}
          role="dialog"
          aria-modal="true"
          onClick={handleOverlayClick}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2, ease: 'easeInOut' }}
        >
          <motion.div
            data-cy="modal-overlay"
            className="absolute inset-0 bg-black/80 pointer-events-auto"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2, ease: 'easeInOut' }}
          />

          <motion.div
            data-cy="modal-content"
            onClick={(event) => event.stopPropagation()}
            className={cn(
              'relative z-30 max-w-full max-h-full h-screen md:max-h-[90vh] overflow-auto',
              !isVerifyModal && 'md:h-fit',
              modal.className,
            )}
            initial={{ scale: 0.95, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.95, opacity: 0 }}
            transition={{ duration: 0.2, ease: 'easeInOut' }}
          >
            {modal.showCloseButton && (
              <Button
                data-cy="modal-close-button"
                icon="Close"
                variant="ghost"
                size="small"
                className="absolute top-3 right-3 z-[2147483646] modal-close-button sm:hover:bg-foreground/0"
                aria-label="fechar modal"
                onClick={handleCloseButton}
              />
            )}

            {typeof modal.Component === 'function' ? (
              <modal.Component />
            ) : (
              (modal.Component ?? modal.content)
            )}

            {preventingComponent && (
              <div className="absolute inset-0 z-[1050] bg-black/70 flex items-center justify-center">
                <div
                  onClick={(e) => e.stopPropagation()}
                  className="bg-background rounded-lg p-4 shadow-lg"
                >
                  {preventingComponent}
                </div>
              </div>
            )}
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
